// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-map-button-control {
  cursor: pointer;
}
wm-map-button-control .wm-map-button-control-button {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: normal;
  align-items: normal;
  align-content: normal;
}
wm-map-button-control .wm-map-button-control-button .selected {
  border: 4px solid var(--wm-color-primary);
  border-radius: 4px;
}
wm-map-button-control .wm-map-button-control-button .wm-map-button-control-icon {
  height: 40px;
  width: 40px;
  min-width: 40px;
  margin-right: 5px;
  background-color: lightgray;
}
wm-map-button-control .wm-map-button-control-button .wm-map-button-control-icon svg {
  height: 100%;
  width: 100%;
}
wm-map-button-control .wm-map-button-control-button .wm-map-button-control-label {
  display: block;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  align-self: center;
  order: 0;
}
wm-map-button-control .wm-map-sub-button-control-button {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: normal;
  align-items: normal;
  align-content: normal;
}
wm-map-button-control .wm-map-sub-button-control-button .selected {
  border: 4px solid var(--wm-color-primary);
  border-radius: 4px;
}
wm-map-button-control .wm-map-sub-button-control-button .wm-map-button-control-icon {
  height: 20px;
  width: 20px;
  min-width: 20px;
  margin-left: 5px;
}
wm-map-button-control .wm-map-sub-button-control-button .wm-map-button-control-icon svg {
  height: 100%;
  width: 100%;
}
wm-map-button-control .wm-map-sub-button-control-button .wm-map-button-control-label {
  display: block;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  align-self: center;
  order: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/map-core/src/components/controls/button/button.controls.map.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AAAE;EAKE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAFJ;AAPI;EACE,yCAAA;EACA,kBAAA;AASN;AADI;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAGN;AADM;EACE,YAAA;EACA,WAAA;AAGR;AAAI;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;AAEN;AACE;EAKE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAHJ;AANI;EACE,yCAAA;EACA,kBAAA;AAQN;AAAI;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAEN;AAAM;EACE,YAAA;EACA,WAAA;AAER;AACI;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;AACN","sourcesContent":["wm-map-button-control {\n  cursor: pointer;\n  .wm-map-button-control-button {\n    .selected {\n      border: 4px solid var(--wm-color-primary);\n      border-radius: 4px;\n    }\n    display: inline-flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: normal;\n    align-items: normal;\n    align-content: normal;\n    .wm-map-button-control-icon {\n      height: 40px;\n      width: 40px;\n      min-width: 40px;\n      margin-right: 5px;\n      background-color: lightgray;\n\n      svg {\n        height: 100%;\n        width: 100%;\n      }\n    }\n    .wm-map-button-control-label {\n      display: block;\n      flex-grow: 1;\n      flex-shrink: 1;\n      flex-basis: auto;\n      align-self: center;\n      order: 0;\n    }\n  }\n  .wm-map-sub-button-control-button {\n    .selected {\n      border: 4px solid var(--wm-color-primary);\n      border-radius: 4px;\n    }\n    display: inline-flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: normal;\n    align-items: normal;\n    align-content: normal;\n    .wm-map-button-control-icon {\n      height: 20px;\n      width: 20px;\n      min-width: 20px;\n      margin-left: 5px;\n\n      svg {\n        height: 100%;\n        width: 100%;\n      }\n    }\n    .wm-map-button-control-label {\n      display: block;\n      flex-grow: 1;\n      flex-shrink: 1;\n      flex-basis: auto;\n      align-self: center;\n      order: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
